// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "FourOhFour-module--cds--assistive-text--155d2";
export var cdsVisuallyHidden = "FourOhFour-module--cds--visually-hidden--a7ab0";
export var container = "FourOhFour-module--container--08708";
export var fourOhFour = "FourOhFour-module--four-oh-four--68bb7";
export var gradient = "FourOhFour-module--gradient--748c5";
export var heading = "FourOhFour-module--heading--7cf20";
export var hideFeedback = "FourOhFour-module--hide-feedback--ab718";
export var link = "FourOhFour-module--link--b7e36";
export var list = "FourOhFour-module--list--92c9b";
export var paragraph = "FourOhFour-module--paragraph--1d225";
export var showFeedback = "FourOhFour-module--show-feedback--33aaf";
export var skeleton = "FourOhFour-module--skeleton--a8702";